import { OraclePrompt } from '@modules/oracle/store/types';
import {
  AssistantResponseStep,
  AssistantResponseStepAnswer,
} from 'generated/graphql';
import { cloneDeep } from 'lodash';

interface updatePromptByIDParams {
  editedFromResponseID?: string;
  editedStepID?: string;
  newPromptID: string;
  promptByID: Record<string, OraclePrompt>;
  newPromptData?: {
    question: string;
    userID: string;
    tenantID: string;
    previousResponseID?: string;
  };
}

export function updatePromptByID({
  promptByID,
  editedFromResponseID,
  newPromptID,
  editedStepID,
  newPromptData,
}: updatePromptByIDParams): Record<string, OraclePrompt> {
  const updatedPromptByID = cloneDeep(promptByID);

  if (editedFromResponseID) {
    const currentPromptClone = cloneDeep(
      updatedPromptByID[editedFromResponseID],
    );
    const currentStepIndex =
      currentPromptClone.assistantResponse?.steps?.findIndex(
        (step) => editedStepID === step.id,
      );
    let steps: AssistantResponseStep[] | undefined = undefined;
    let stepAnswerByID:
      | Record<string, AssistantResponseStepAnswer>
      | undefined = undefined;

    if (currentStepIndex !== undefined && currentStepIndex !== -1) {
      steps = currentPromptClone.assistantResponse?.steps;
      stepAnswerByID = currentPromptClone.assistantResponse?.stepAnswerByID;

      const deletedSteps = steps?.splice(currentStepIndex, steps.length - 1);
      deletedSteps?.forEach((step) => {
        delete stepAnswerByID?.[step.id];
      });
    }

    // Add new entry
    updatedPromptByID[newPromptID] = {
      ...currentPromptClone,
      ...newPromptData,
      previousResponseID: currentPromptClone.previousResponseID,
      id: newPromptID,
      createdAt: Date.now(),
      editedFromResponseID,
      assistantResponse: {
        steps,
        stepAnswerByID,
      },
      editedToResponseID: undefined,
      endOfResponse: false,
      error: undefined,
      isResponseHalted: false,
      isEdited: false,
    };

    // Add link from current prompt to new prompt
    updatedPromptByID[editedFromResponseID] = {
      ...updatedPromptByID[editedFromResponseID],
      editedToResponseID: newPromptID,
      isEdited: true,
    };
  } else if (newPromptData) {
    updatedPromptByID[newPromptID] = {
      ...newPromptData,
      id: newPromptID,
      createdAt: Date.now(),
      userQuoteByExampleID: {},
    };
  }

  // Add link from previous prompt to new prompt
  const previousResponseID = editedFromResponseID
    ? updatedPromptByID[editedFromResponseID].previousResponseID
    : newPromptData?.previousResponseID;
  if (previousResponseID) {
    updatedPromptByID[previousResponseID] = {
      ...updatedPromptByID[previousResponseID],
      nextResponseIDs: [
        ...(updatedPromptByID[previousResponseID].nextResponseIDs ?? []),
        newPromptID,
      ],
    };
  }

  return updatedPromptByID;
}
